/**
 * DI-3-F — `POST …/data-acquisitions/{id}/withhold` (intake/v1 1.11.0, the BE
 * half of DI-3-F). No body. A partner (withholding) set's images stay on the
 * pilot's PC: the gateway marks every image `withheld` and moves the set to
 * `withheld_complete`, after which Approve finalizes it metadata-only.
 *
 *   200 `{intakeState: withheld_complete, imagesWithheld}` — a replay on a
 *       withheld set answers 200 with `imagesWithheld: 0`;
 *   409 `da_not_created` · `workflow_uploads` (the workflow uploads — never
 *       withhold it) · `intake_state_invalid` (not `verdict_ready` /
 *       `needs_info` yet).
 */
import type { IntakeComponents } from "@aeriosiq/types";
import { intakeFetch } from "./intakeFetch.js";

export type WithholdAccepted = IntakeComponents["schemas"]["WithholdAccepted"];

export function withholdIntake(daId: string): Promise<WithholdAccepted> {
  return intakeFetch<WithholdAccepted>(
    `/data-acquisitions/${encodeURIComponent(daId)}/withhold`,
    { method: "POST" },
  );
}
